module.exports = __webpack_public_path__ + "img/1.1f9a5834.png";